mutation PayCycleRowProtection($input: PayCycleRowProtectionInput!) {
  payCycleRowProtection(input: $input) {
    secureRowLevel {
      id
      name
    }
  }
}
